module.exports = __webpack_public_path__ + "img/nuevo_usuario.60921ea6.svg";